
import * as React from 'react';
import "../../App.css"
import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import {useNavigate } from "react-router-dom";
import error404_img from "../../asset/images/error/error.jpeg"
function PageError() {
    const navigate = useNavigate();
    const handleGoHome = () => {
        navigate('/');
    }
    return (
        <>
            <Container>
                <Row >
                    <Col sm={12}>
                        <div className="text-center">
                            <div className="mt-4 mb-3">
                                <Image src={error404_img} alt="" className="img-fluid" />
                            </div>
                            <h1 className="display-4 fw-bold">Oops! the page not found.</h1>
                            <p className="mb-4">Or simply leverage the expertise of our consultation
                                team.</p>
                            <Button className="btn btn-primary" onClick={handleGoHome}>
                                Go Home
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default PageError;